import { Link } from 'react-router';

import DieDasDerImg from 'assets/diedasder-icon.png';
import 'app/styles/content.css';

const Projects = () => (
  <div className="container">
    <div className="content page">
      <Link to="/">
        <div className="close">
          Close
          <span className="close-icon">X</span>
        </div>
      </Link>
      <h1>Projects</h1>
      <h2>
        <a className="link header-link" href="https://diedasder.app">DieDasDer</a>
      </h2>
      <h3>Build intuition for German articles</h3>
      <a href="https://diedasder.app">
        <img src={DieDasDerImg} alt="DieDasDer" />
      </a>
      <p>
        {[
          'A simple and minimalistic game that helps you master German articles',
          'using smart repetition. Practice the most common German words across multiple levels',
          'and topics with carefully curated vocabulary. Get instant feedback, save tricky words,',
          'review your mistakes, or challenge yourself to guess as many articles as possible.',
        ].join(' ')}
      </p>
      <a className="link text-link" href="https://diedasder.app">https://diedasder.app</a>
      <hr />
    </div>
  </div>
);

export default Projects;
